import styled, {keyframes} from 'styled-components';
import { Button } from 'global/styles/styles.js';
import { rem } from 'polished';
import Modal from 'Modal.js';
const baseFont = '12px';
const S = {};

const duration = 1000;
const durationAnimation = 3;

S.AccountCashback = styled.div`
    width: 100%;
`;

S.AccountCashbackWithdraw = styled.div`
    background-color: ${({theme:{$accountProfileCashbackWithdrawBg}})=> $accountProfileCashbackWithdrawBg};
    width: calc(100% - 10px);
    padding: 2rem 5px 1rem 5px;
    text-align: center; 
`;

S.AccountCashbackWrapper = styled.form`
    width: 100%;
    height: ${rem('80px', baseFont)};
`;

S.TopRow = styled.div`
    width: 100%;
    height: ${rem('16px', baseFont)};
    line-height: ${rem('16px', baseFont)};
`;

S.ArrowBack = styled.i`
    width: ${rem('15px', baseFont)};
    height: ${rem('15px', baseFont)};
    display: inline-block;
    float: left;
    margin-left: 0px;
    margin-right: ${rem('10px', baseFont)};
`;

S.BalanceLabel = styled.div`
    font-size: ${rem('18px', baseFont)};
    display: inline-block;
    float: left;
    font-weight: 600;
`;

S.BalanceAmount = styled.div`
    font-size: ${rem('18px', baseFont)};
    font-weight: 600;
    display: inline-block;
    float: right;
    color: ${({theme:{$accountProfileCashbackAmount}})=> $accountProfileCashbackAmount};
`;

S.AccountCashbackMessage = styled.div`
    font-size: ${rem('14px', baseFont)};
`; 

S.WithdrawButton = styled(Button)`
    width: 100%;
    font-size: ${rem('10px', baseFont)};
    text-transform: uppercase;
    height: ${rem('32px', baseFont)};
    line-height: ${rem('32px', baseFont)};
    cursor: pointer;
    margin-top: 2rem;
    background-color: ${({theme:{$accountProfileCashbackFilterButtonBgActive}})=> $accountProfileCashbackFilterButtonBgActive};
    color: ${({theme:{$accountProfileCashbackButtonColorActive}})=> $accountProfileCashbackButtonColorActive};
    border-radius: 3px;
    
    &[disabled]{
        visibility: hidden;
    }
    &[data-active=true]{
        pointer-events: none;
    }
`;

S.AccountCashbackList = styled.div`
    width: calc(100% - 10px);
    padding: 1.5rem 5px;
`;


S.CashbackFiltersLabel = styled.div`
    font-size: ${rem('16px', baseFont)};
    width: 100%;
    text-align: center;
`;

S.CashbackFiltersDates = styled.div`
    display: flex;
    width: 100%;
    position: relative;
    & > div{
         margin-right: 10px;
         &:last-of-type{
             margin-right: 0;
         }
    }
`;

S.Datepicker = styled.div`
   position: relative;
   display: flex;
   height: 42px;
   width: 100%;
   border: 1px solid rgba(0, 0, 0, 0.24);
   border-radius: 3px;

   &:first-child {
    margin-right: 10px;
   }

   input[type="date"] {
    -o-appearance: none;
    -ms-appearance: none;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;

    flex: 1 1 0%;
    padding: 0;
    padding-left: 10px;
    background-color: ${({theme:{$datepickerInputBg}})=> $datepickerInputBg};
    border: none;
    border-radius: 0;
    height: 100%;
    font-size: 14px;
    font-weight: 500;
    width: 100%;
    color: ${({theme:{$datepickerInputColor}})=> $datepickerInputColor};
    outline: none;

    &::-webkit-calendar-picker-indicator {
        padding: 0;
        opacity: 0;
        margin: 0;
    }
   }
`;

S.IconContainer = styled.div`
    width: 20%;
    position: relative;
    background-color: ${({theme:{$accountProfileBetHistoryDatepickerLabelBg}})=> $accountProfileBetHistoryDatepickerLabelBg};
`;

S.DateLabel = styled.div`
    display: flex;
    font-weight: 400;
    color: ${({theme:{$datepickerLabelColor}})=> $datepickerLabelColor};
    background-color: ${({theme:{$datepickerLabelBg}})=> $datepickerLabelBg};
    padding-left: 0.75rem;
    justify-content: center;
    align-items: center;
    border-radius: 3px;
    font-size: 14px;
`;
S.DateIcon = styled.i`
    position: absolute;
    right: 0;
    top: 0;
    display: flex;
    height: 100%;
    width: 33px;
    font-size: 1.67rem;
    color: #565656;
    justify-content: center;
    align-items: center;
    pointer-events: none;
`;

S.CashbackFiltersBtns = styled.div`
    display: flex;
    width: 100%;
    margin-bottom: 1rem;
    margin-top: 1rem;
    & > button{
        width: calc(50% - 10px);
        margin-right: 10px;
        &:last-of-type{
            margin-right: 0;
            margin-left: 10px;
            float: right;
        }
    }
`;
S.FilterBtn = styled(Button)`
    margin-top: 0;
    background-color: ${({theme:{$accountProfileCashbackFilterButtonBg}})=> $accountProfileCashbackFilterButtonBg};
    color: ${({theme:{$accountProfileCashbackButtonColor}})=> $accountProfileCashbackButtonColor};
    font-weight: 400;
    text-overflow: ellipsis;
    overflow: hidden;
    border-radius: 4px;
    display: block;
    justify-content: center;
    align-items: center;
    text-transform: uppercase;
    position: relative
    white-space: nowrap;
    height: ${rem('28px', baseFont)};
    line-height: ${rem('28px', baseFont)};

    &.active {
        background-color: ${({theme:{$accountProfileCashbackFilterButtonBgActive}})=> $accountProfileCashbackFilterButtonBgActive};
        color: ${({theme:{$accountProfileCashbackButtonColorActive}})=> $accountProfileCashbackButtonColorActive};
    }
`;

S.Table = styled.table`
    width: 100%;
    margin: auto;
    margin-bottom: 20px;
    margin-top: 10px;
`;

S.Head = styled.thead`
    & .row {
        border-bottom: 2px solid ${({theme:{$accountProfileCashbackButtonBg}})=> $accountProfileCashbackButtonBg};
    }
`;

S.Body = styled.tbody``;

S.Row = styled.tr`
    border-top: 0;

    &.odd {
        background-color: ${({theme:{$accountProfileCashbackWithdrawBg}})=> $accountProfileCashbackWithdrawBg};
    }

    &.even {

    }

    &:before,
    &:after{
     display: none !important;
    }
    
    &.no-result{
        height: 40px;
        padding: 0 1.25rem;
        line-height: 4rem!important;
        font-size: 1rem;
      
        & > td{
            text-align: center;
        }
    }
`;

S.Td = styled.td`
    padding: 1rem 0rem;
    font-size: 0.70rem;
    vertical-align: top;
    text-align: center;

    &.slip-id {
        width: 24%;
    }
    &.time {
        width: 20%;
    }
    &.name {
        width: 33%;
    }
    &.paid {
        width: 23%;
    }
`;

S.Th = styled.th`
    padding: 0rem;
    font-size: 0.70rem;
    font-weight: 400;
    line-height: 1.5;
    vertical-align: bottom;
    border-top: 0;
    text-align: center;

    &.slip-id {
        width: 24%;
    }
    &.time {
        width: 20%;
    }
    &.name {
        width: 33%;
    }
    &.paid {
        width: 23%;
    }
`;

S.CashbackList = styled.div``;

const ModalWithOpacityStyles = styled(Modal)`
  
  &.modal-opacity-enter {
    opacity: 0.01;
  }
  &.modal-opacity-enter-active {
   transition: opacity ${duration}ms;
   opacity: 1;
  }
  &.modal-opacity-exit {
    opacity: 1;
  }
  &.modal-opacity-exit-active {
    opacity: 0.01;
    transition: opacity ${duration}ms ease-in;
  }

`;

S.AccountCashbackWithdrawModal = styled.div`
    background-color: rgb(255, 255, 255);
    background-image: url('/images/cashout-modal-bg.png');
    background-size: cover;
    box-shadow: rgba(0, 0, 0, 0.75) 0px 0.25em 1em 0px;
    color: white;
    height: ${rem('360px', baseFont)};
    width: 100%;
    padding: 1rem 0 1rem 0;
    text-align: center;
`;

S.AccountCashbackWithdrawModalStep1 = styled.div`
`;

S.AccountCashbackWithdrawModalStep2 = styled.div`
`;

const blurAnimation = keyframes`
  0% {
    filter: blur(0px);
  }
  50% {
    filter: blur(5px);
  }
  100% {
    filter: blur(5px);
  }
`;

S.AccountCashbackWithdrawModalText = styled.div`
    text-transform: uppercase;
    font-size: ${rem('28px', baseFont)};

    &.modal-text-animation {
        animation-direction: normal;
        animation-duration: ${durationAnimation}s;
        animation-iteration-count: 1;
        animation-name: ${blurAnimation};
        animation-timing-function: ease-in;
    }

`;

S.AccountCashbackWithdrawModalTextSmall = styled.div`
    text-transform: uppercase;
    font-size: ${rem('15px', baseFont)};
`;

S.AccountCashbackWithdrawModalButton = styled.div`
    text-transform: uppercase;
    color: #000;
    background-color: #fff;
    font-size: 1.4rem;
    margin: 10px 30px 0px 30px;
    cursor: pointer;
    padding: 0.5rem;
    font-weight: bold;
`;

S.AccountCashbackSuccessIcon = styled.div`
    background: url(/images/svg/check-mark-icon.svg);
    background-position: center;
    margin: auto;
    width: 140px;
    height: 140px;
    margin-top: 30px;
    margin-bottom: 20px;
`;

S.AccountCashbackMoney = styled.div`
    background: url(/images/money.gif);
    background-position: center;
    width: 200px;
    height: 300px;
    margin-top: 0px;
    margin-left: 80px;
`;

export default S;